import { memo } from 'react';

import { PrivateSearchClearButton } from '~/components/Search/PrivateSearchClearButton';
import { PrivateSearchSaveFilterButton } from '~/components/Search/PrivateSearchSaveFilterButton';
import { useAppliedFiltersCount } from '~/hooks/filters/useAppliedFiltersCount';
import { useSearchParams } from '~/hooks/search/useSearchParams';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { canCreateSavedFilters } from '~/utils/permissions/workspacePermissions';

export type PrivatePageSearchActionsProps = {
  onClearSearchValue: () => void;
};

export const PrivatePageSearchActions = memo(({ onClearSearchValue }: PrivatePageSearchActionsProps) => {
  const { filtersCount, filtersCanBeSaved } = useAppliedFiltersCount();
  const { search } = useSearchParams();
  const { data: permissions } = useCurrentWorkspacePermissionsContext();
  const canAddSavedFilters = canCreateSavedFilters(permissions);

  return (
    <>
      {filtersCanBeSaved && canAddSavedFilters && <PrivateSearchSaveFilterButton />}
      {(!!filtersCount || !!search) && <PrivateSearchClearButton onClick={onClearSearchValue} />}
    </>
  );
});

PrivatePageSearchActions.displayName = 'PrivatePageSearchActions';
